import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import './assets/style/style.styl'
import { Common } from './common'
import { Api } from 'api'
import ElementUI from 'element-ui'

Vue.prototype.$http = axios
Vue.prototype.api = Api
Vue.prototype.common = Common
Vue.config.productionTip = false

Vue.use(ElementUI)

axios.defaults.withCredentials = true

if (process.env.NODE_ENV !== 'development') {
  router.beforeEach(async (to, from, next) => { // 权限验证
    console.log(Common.getCookie('QDS_COOKIE'))
    if (Common.getCookie('QDS_COOKIE') || Common.getCookie('QDS_LOGIN_INFO')) {
      next()
    } else {
      return (window.location.href = `https://account.quandashi.com/?callback=${encodeURIComponent(`${Api.gonggaoPrefix}`)}`)
    }
  })
}

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js